import { render, staticRenderFns } from "./OrderFormStep6BuddhistNameTab.module.vue?vue&type=template&id=ad523a3a&scoped=true&"
import script from "./OrderFormStep6BuddhistNameTab.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep6BuddhistNameTab.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep6BuddhistNameTab.module.vue?vue&type=style&index=0&id=ad523a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad523a3a",
  null
  
)

export default component.exports